/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MarketReceiptIcon16Light } from './MarketReceiptIcon16Light';
import { MarketReceiptIcon16Regular } from './MarketReceiptIcon16Regular';
import { MarketReceiptIcon16Solid } from './MarketReceiptIcon16Solid';
import { MarketReceiptIcon20Light } from './MarketReceiptIcon20Light';
import { MarketReceiptIcon20Regular } from './MarketReceiptIcon20Regular';
import { MarketReceiptIcon20Solid } from './MarketReceiptIcon20Solid';
import { MarketReceiptIcon24Regular } from './MarketReceiptIcon24Regular';
import { MarketReceiptIcon24Solid } from './MarketReceiptIcon24Solid';
import { MarketReceiptIcon32Regular } from './MarketReceiptIcon32Regular';
import { MarketReceiptIcon64Regular } from './MarketReceiptIcon64Regular';
var sizes = {
    16: {
        light: MarketReceiptIcon16Light,
        regular: MarketReceiptIcon16Regular,
        solid: MarketReceiptIcon16Solid,
    },
    20: {
        light: MarketReceiptIcon20Light,
        regular: MarketReceiptIcon20Regular,
        solid: MarketReceiptIcon20Solid,
    },
    24: {
        regular: MarketReceiptIcon24Regular,
        solid: MarketReceiptIcon24Solid,
    },
    32: {
        regular: MarketReceiptIcon32Regular,
    },
    64: {
        regular: MarketReceiptIcon64Regular,
    },
};
export var MarketReceiptIcon = forwardRef('MarketReceiptIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
